export function checkInPhysicalAlbum(id: string, array: Array<any>) {
  return array?.some((pa: { id: string }) => pa?.id === id)
}
